import {
  ResponseUpdateInfoResponsible,
  UpdateInfoResponsible
} from '@/modules/responsible/domains/models/update-info-responsible'

import { axios, Response } from '..'

const updateInfoResponsible = (
  responsibleId: string,
  body: UpdateInfoResponsible
): Response<ResponseUpdateInfoResponsible> => {
  return axios.put(`/v1/responsible/${responsibleId}`, body)
}

export default updateInfoResponsible
